import { Box, Card, CardContent, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, InputAdornment, Grid } from '@mui/material';
import { Search, Download, Print } from '@mui/icons-material';
import { libroVentasCCF } from '../billingData';

const BookSalesCCF = () => {
  const totalVentas = libroVentasCCF.reduce((acc, doc) => acc + doc.ventas, 0);
  const totalIVA = libroVentasCCF.reduce((acc, doc) => acc + doc.iva, 0);
  const totalGeneral = libroVentasCCF.reduce((acc, doc) => acc + doc.total, 0);

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom>
            Libro de Ventas - Crédito Fiscal
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Registro de ventas a contribuyentes con derecho a crédito fiscal
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" startIcon={<Print />}>
            Imprimir
          </Button>
          <Button variant="contained" startIcon={<Download />} color="primary">
            Exportar Excel
          </Button>
        </Box>
      </Box>

      {/* Stats */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={4}>
          <Card sx={{ backgroundColor: '#e3f2fd' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Total Ventas</Typography>
              <Typography variant="h4" color="primary">${totalVentas.toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card sx={{ backgroundColor: '#fff3e0' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">IVA Debitable</Typography>
              <Typography variant="h4" color="warning.main">${totalIVA.toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card sx={{ backgroundColor: '#e8f5e9' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Total General</Typography>
              <Typography variant="h4" color="success.main">${totalGeneral.toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Filters */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Desde"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Hasta"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Button variant="outlined" fullWidth>
                Generar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Table */}
      <Card>
        <CardContent>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell sx={{ fontWeight: 'bold' }}>Fecha</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Documento</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Cliente</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>NIT</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Ventas</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">IVA</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {libroVentasCCF.map((doc, index) => (
                  <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#fafafa' } }}>
                    <TableCell>{doc.fecha}</TableCell>
                    <TableCell>{doc.documento}</TableCell>
                    <TableCell>{doc.cliente}</TableCell>
                    <TableCell>{doc.nit}</TableCell>
                    <TableCell align="right">${doc.ventas.toFixed(2)}</TableCell>
                    <TableCell align="right">${doc.iva.toFixed(2)}</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 500 }}>${doc.total.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow sx={{ backgroundColor: '#e3f2fd', fontWeight: 'bold' }}>
                  <TableCell colSpan={4} sx={{ fontWeight: 'bold' }}>TOTALES</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>${totalVentas.toFixed(2)}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>${totalIVA.toFixed(2)}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>${totalGeneral.toFixed(2)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Info */}
      <Card sx={{ mt: 3, backgroundColor: '#f5f5f5' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Libro de Ventas - Crédito Fiscal
          </Typography>
          <Typography variant="body2">
            Este libro registra las ventas realizadas a contribuyentes (empresas con NIT válido). Estos documentos 
            generan crédito fiscal para el comprador y son requeridos para la declaración de IVA.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BookSalesCCF;
